import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductType, PRODUCT_TYPES } from '@apps/api-interfaces';
import { Destroyer } from '@apps/tools';
import { ErrorMessageComponent, FormSubmitDirective, phoneNumberValidator, zipCodeValidator } from '@apps/ui';
import { takeUntil } from 'rxjs/operators';
import { WIDGET_NAME } from './config';
import { ERRORS } from './errors';

export enum Step {
  zip,
  phone,
  term
}

const getPathname = (): ProductType => {
  let url = window.location.pathname;
  if (url.indexOf('?') > -1) {
    url = url.substring(0, url.indexOf('?'));
  }

  const all = PRODUCT_TYPES.map(e => e.id);
  const path = url.split('/');

  if (all.includes(path && path[1])) {
    return path[1] as ProductType;
  }

  if (all.includes(path && path[2])) {
    return path[2] as ProductType;
  }

  return all[2] as ProductType;
};

const getDomain = (): string => {
  return 'https://zatrzymajlicznik.pl';
};

@Component({
  selector: 'scw-zip',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent extends Destroyer implements OnInit {
  @Input() cid: string;
  @Input() zipcode: string;
  @Input() align: 'left' | 'right' | 'center' = 'center';
  @Input() border: any;
  @Input() button1 = 'Rozpocznij';
  @Input() button2 = 'Dalej';
  @Input() button3 = 'Pokaż wycenę';
  @Input() product: ProductType = getPathname();
  @Input() text1_fotowoltaika = 'Wpisz kod pocztowy <nobr>i uzyskaj</nobr> szybką wycenę';
  @Input() text1_gaz = 'Wpisz kod pocztowy <nobr>i uzyskaj</nobr> szybką wycenę';
  @Input() text1_prad = 'Wpisz kod pocztowy <nobr>i uzyskaj</nobr> szybką wycenę';
  @Input() text2 = 'Szanujemy prywatność,<br /> nikomu nie przekażemy Twojego numeru';
  @Input() text3 = 'Tylko po akceptacji standardowego regulaminu, możemy pokazać ofertę';
  @Input() extras = {};
  @Input() ng: boolean;
  
  form: FormGroup;
  steps = Step;
  currentStep: Step;
  errors = ERRORS;
  submitted = false;

  @ViewChild('formRef', { static: false, read: FormSubmitDirective })
  formRef: FormSubmitDirective;

  @ViewChildren('errorRef', { read: ErrorMessageComponent })
  errorRefs: QueryList<ErrorMessageComponent>;

  @Output() onsubmit: EventEmitter<any> = new EventEmitter();

  get text1(): string {
    return this[`text1_${ this.product }`];
  }

  private domain: string = getDomain();

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.currentStep = Step.zip;

    this.form = this.fb.group({
      zip: [null, [Validators.required, zipCodeValidator]],
      phone: [null, [Validators.required, phoneNumberValidator]],
      term: [false, Validators.requiredTrue]
    });

    this.form.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.submitted = false;
        this.cdr.detectChanges();
      })
  }

  nextStep(event: MouseEvent) {
    event.preventDefault();
    this.submitted = true;

    if (this.form.valid) {
      this.redirect();
      return;
    }

    if (this.form.get(this.steps[this.currentStep]).valid) {
      this.currentStep += 1;
    }

    this.cdr.detectChanges();
  }

  resetErrors() {
    this.formRef.resetSubmit();
    this.errorRefs.toArray().forEach(err => {
      err.reset();
    });
  }

  private redirect() {
    let data = Object.assign(
      { source: WIDGET_NAME },
      this.extras,
      this.form.value
    );
    if (this.cid) {
      data['cid'] = this.cid;
    }

    const params = new URLSearchParams(data).toString();
    const url = `/porownywarka/${ this.product }/kalkulator?${ params }`;

    if (this.ng) {
      this.onsubmit.emit({
        url, data
      });
      return;
    }

    window.location.href = `${this.domain}${url}`;
  }
}
